<template>
  <div class="apCheckbox">
    <input
      type="checkbox"
      class="apCheckbox__input"
      :checked="checked"
      @input="input"
    />
    <div class="apCheckbox__box"></div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
  
export default defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }){
    const input = (e: Event) : void => {
      const element = e.target as HTMLInputElement;
      emit('update:checked', element.checked);
    };
    return {
      input
    };
  }
});
</script>
  
  <style lang="scss" scoped>
  .apCheckbox{
    position: relative;
    &__input{
      cursor: pointer;
      position: absolute;
      opacity: 0;
      overflow: hidden;
    }
    &__box{
      margin: 0;
      width: 18px;
      height: 18px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2 0H16C17.1046 0 18 0.89543 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0ZM16 16V2H2V16H16Z' fill='%23646468'/%3E%3C/svg%3E");
    }
  }
  .apCheckbox__input:checked + .apCheckbox__box{
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 16 16' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 2.4C0 1.07452 1.07452 0 2.4 0H13.6C14.9255 0 16 1.07452 16 2.4V13.6C16 14.9255 14.9255 16 13.6 16H2.4C1.07452 16 0 14.9255 0 13.6V2.4Z' fill='%236059F4'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.9306 5.03125C12.243 5.34367 12.243 5.8502 11.9306 6.16262L6.9649 11.3626C6.65249 11.675 6.14595 11.675 5.83353 11.3626L3.43353 8.96262C3.12111 8.6502 3.12111 8.14367 3.43353 7.83125C3.74595 7.51883 4.25248 7.51883 4.5649 7.83125L6.39922 9.66557L10.7992 5.03125C11.1116 4.71883 11.6182 4.71883 11.9306 5.03125Z' fill='white'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
  }
  .tele2{
    .apCheckbox__input:checked + .apCheckbox__box{
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16 0H2C0.89543 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.89543 17.1046 0 16 0ZM16 16H2V2H16V16ZM7.35 12.5015C7.21741 12.5015 7.09073 12.4467 7 12.35L4.62 9.98C4.52534 9.88612 4.4721 9.75832 4.4721 9.625C4.4721 9.49168 4.52534 9.36388 4.62 9.27L5.15 8.74C5.24073 8.64332 5.36741 8.58848 5.5 8.58848C5.63259 8.58848 5.75927 8.64332 5.85 8.74L7.35 10.23L12.09 5.49C12.2844 5.29943 12.5956 5.29943 12.79 5.49L13.32 6.02C13.4147 6.11388 13.4679 6.24168 13.4679 6.375C13.4679 6.50832 13.4147 6.63612 13.32 6.73L7.7 12.35C7.60927 12.4467 7.48259 12.5015 7.35 12.5015Z' fill='%230098DC'/%3E%3C/svg%3E");
    }
  }
  .altel{
    .apCheckbox__input:checked + .apCheckbox__box{
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16 0H2C0.89543 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.89543 17.1046 0 16 0ZM16 16H2V2H16V16ZM7.35 12.5015C7.21741 12.5015 7.09073 12.4467 7 12.35L4.62 9.98C4.52534 9.88612 4.4721 9.75832 4.4721 9.625C4.4721 9.49168 4.52534 9.36388 4.62 9.27L5.15 8.74C5.24073 8.64332 5.36741 8.58848 5.5 8.58848C5.63259 8.58848 5.75927 8.64332 5.85 8.74L7.35 10.23L12.09 5.49C12.2844 5.29943 12.5956 5.29943 12.79 5.49L13.32 6.02C13.4147 6.11388 13.4679 6.24168 13.4679 6.375C13.4679 6.50832 13.4147 6.63612 13.32 6.73L7.7 12.35C7.60927 12.4467 7.48259 12.5015 7.35 12.5015Z' fill='%23E5007C'/%3E%3C/svg%3E");
    }
  }
  </style>